// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"55d182b7","787":"fe3a07ec"}[chunkId] + ".chunk.js";
};